import React from 'react';
import CategoryList from './CategoryList';
import CategoryListFilters from './CategoryListFilters';
import Header from '../../Header'

const ExpenseDashboardPage = () => (
    <div>
        <div className="page-header">
            <div className="content-container">
                <h1 className="page-header__title">Add Category</h1>
                <Header />
            </div>
        </div>
        <CategoryListFilters />
        <CategoryList />
    </div>
);

export default ExpenseDashboardPage;



// WEBPACK FOOTER //
// ./src/components/Category/Dashboard/CategoryDashboardPage.js